<!-- TODO Ionic removal: think about using a card component here instead of ui-section -->
<div class="medium-padding bg-light">
    <div class="display-flex space-between">
        <div>
            <edit-text [disabled]="!hasTileAdminOption" [(ngModel)]="tileData.name" (ngModelChange)="updateTileName()" />
            @if (!tileData.error) {
                <p class="ipe-subtitle" ellipsisWithTitleFallback>
                    {{ subtitle | translate }}
                </p>
            } @else {
                <p class="ipe-subtitle">
                    <ui-icon name="warning" color="danger" size="small" />
                    <span class="ipe-error">{{ 'IPE.' + tileData.error | translate }}</span>
                </p>
            }
        </div>
        <span>
            @if (hasTileAdminOption) {
                <ui-icon-button iconName="configure" size="small" (click)="editTile($event)" />
                <ui-icon-button iconName="delete" size="small" (click)="deleteTile($event)" />
            }
        </span>
    </div>
    <div class="outer">
        <div #chartCanvas class="chart-container"></div>
    </div>
</div>
